module.exports = __webpack_public_path__ + "static/media/Credits-21.7a3fe14e.pdf";